'use client';

import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

/**
 * Wraps any layout component so a client-side crash renders `null`
 * instead of propagating to global-error.tsx.
 *
 * Next.js [locale]/error.tsx only covers the page segment — layout
 * components (Header, Footer, etc.) are outside that boundary and would
 * otherwise trigger the root global-error page on any render throw.
 */
export class SafeMount extends Component<Props, { ok: boolean }> {
  state = { ok: true };

  static getDerivedStateFromError() {
    return { ok: false };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[SafeMount] layout component crash suppressed:', error, info.componentStack);
  }

  render() {
    if (!this.state.ok) return this.props.fallback ?? null;
    return this.props.children;
  }
}
